import React, { useEffect, useState, useCallback } from 'react';
import './DocumentosAgrupados.css';
import { bajarEsquemaCarpetas } from '../../api';
import { PintarCarpeta } from './PintarCarpeta';
import { crearCarpeta } from '../../api/carpetas';
import { IconButton } from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';

export const DocumentosAgrupados = ({ idUsuario, planta, cliente, elementoActivo }) => {
  const [estructura, setEstructura] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchEstructura = useCallback(async () => {
    if (!planta || !elementoActivo || !planta.nombreCliente) return;

    if (!estructura) setLoading(true);

    const nombreLimpio = planta.nombreCliente.replace(/[.,]/g, " ").trim();
    const ofertaStr = planta.numeroOferta ? String(planta.numeroOferta).trim() : "SIN_OFERTA";

    const rutaCarpeta = `C:\\inetpub\\wwwroot\\YC\\Pdf\\${nombreLimpio}\\${ofertaStr}\\Planta_${nombreLimpio}`;
    //const rutaCarpeta = `C:\\Users\\mortiz\\Desktop\\PROYECTOS\\JNEGRE\\JnegreV1.9.6\\BackEnd\\AnalisisQuimicos.Api\\Pdf\\${nombreLimpio}\\${ofertaStr}\\Planta_${nombreLimpio}`;

    console.log("Elemento activo: ", elementoActivo);

    const ofertaFinal = planta.oferta ?? planta.numeroOferta ?? ""

    const elementoParam = elementoActivo.replace(/\s+/g, '_');

    console.log("intentando cargar carpeta: ", elementoActivo, elementoParam);

    try {
      const res = await bajarEsquemaCarpetas(
        planta.nombreCliente,
        planta.codigoCliente,
        ofertaFinal,
        elementoActivo
      );

      if (!res.data || Object.keys(res.data).length === 0) {
        // Si no existe, intentar con '_' al final (ej: ACH -> ACH_)
        const resUnderscore = await bajarEsquemaCarpetas(
          planta.nombreCliente,
          planta.codigoCliente,
          ofertaFinal,
          `${elementoParam}_`
        );

        if (resUnderscore.data && Object.keys(resUnderscore.data).length > 0) {
          setEstructura({ ...resUnderscore.data });
        } else if (elementoParam.endsWith('_')) {
          // Si termina en '_', intentar sin él (ej: ACH_ -> ACH)
          const resSinUnderscore = await bajarEsquemaCarpetas(
            planta.nombreCliente,
            planta.codigoCliente,
            ofertaFinal,
            elementoParam.slice(0, -1)
          );
          if (resSinUnderscore.data && Object.keys(resSinUnderscore.data).length > 0) {
            setEstructura({ ...resSinUnderscore.data });
          } else {
            throw new Error("Carpeta inexistente");
          }
        } else {
          throw new Error("Carpeta inexistente");
        }
      } else {
        setEstructura({ ...res.data });
      }

    } catch (error) {
      if (elementoParam === 'Privado' || elementoActivo === 'Privado') {
        try {
          await crearCarpeta(rutaCarpeta, 'Privado');
          const retry = await bajarEsquemaCarpetas(
            planta.nombreCliente,
            planta.codigoCliente,
            ofertaFinal,
            elementoParam
          );

          if (retry.data && Object.keys(retry.data).length > 0) {
            setEstructura({ ...retry.data });
          } else {
            const retryUnderscore = await bajarEsquemaCarpetas(
              planta.nombreCliente,
              planta.codigoCliente,
              ofertaFinal,
              `${elementoParam}_`
            );
            setEstructura({ ...retryUnderscore.data });
          }
        }  catch (createError) {
          // En lugar de solo console.error, inspecciona la respuesta de la API
          console.log("Detalles del error de creación:", createError.response?.data || createError.message);
          setEstructura(null);
        }
      } else {
        //console.log(`La carpeta para '${elementoActivo}' no existe.`);
        setEstructura(" ");
      }
    } finally {
      setLoading(false);
    }
  }, [planta, elementoActivo]);

  useEffect(() => {
    fetchEstructura();
  }, [fetchEstructura]);

  const actualizarPadre = async () => {
    // Opcional: setEstructura(null); // Descomenta esto si quieres ver el "Cargando" al actualizar
    await fetchEstructura();
  };

  if (estructura != null || estructura === "") {
    return (
      <div className='contenedor'>
        <PintarCarpeta
          carpeta={estructura}
          actualizarPadre={actualizarPadre}
          permisoUsuario={idUsuario}
          carpetaRaiz={estructura.nombre}>
        </PintarCarpeta>
      </div>
    )
  } else {
    return (
      <IconButton>
        <AddBoxIcon />
      </IconButton>
    )
  }
};